<template>
  <div class="container">
    <div class="row mt-5 justify-content-center text-center">
        <div class="col-6 mt-5">
            <b-alert
              :show="alert.show"
              @dismissed='alert.show = false'
              dismissible
              fade
              :variant="alert.type"
            >
              {{ alert.message }}
            </b-alert>

            <form class="mt-5 justify-content-center" role="form" novalidate @submit.prevent>
                <div class="form-group" :class="{ 'has-error': errors.has('serial') }">
                    <input
                        type="serial"
                        name="serial"
                        class="form-control"
                        :placeholder="$t('serial') + ' 1'"
                        v-model="serial1"
                        v-validate="'required'"
                    >

                    <small v-show="errors.has('serial')" class="form-text text-muted text-left">
                        {{ errors.first('serial') }}
                    </small>
                </div>

                <div class="form-group" :class="{ 'has-error': errors.has('serial') }">
                    <input
                        type="serial"
                        name="serial"
                        class="form-control"
                        :placeholder="$t('serial') + ' 2'"
                        v-model="serial2"
                        v-validate="'required'"
                    >

                    <small v-show="errors.has('serial')" class="form-text text-muted text-left">
                        {{ errors.first('serial') }}
                    </small>
                </div>

                <LoaderButton
                    @click="onClick"
                    full
                    type='submit'
                >
                    {{ $t('save') }}
                </LoaderButton>

                <button
                    type="button"
                    class="btn btn-link btn-forget"
                    @click="$router.push({ name: 'login' })"
                >
                    {{ $t('back') }}
                </button>

            </form>
        </div>
    </div>
  </div>
</template>

<script>
import LoaderButton from '@/components/button/LoaderButton'
import { addCls } from '@/lib/ui/domClass'
import { request } from '@/lib/http'

export default {
  name: 'Login',
  components: {
    LoaderButton
  },
  data () {
    return {
        alert: {
            show: false,
            type: '',
            message: ''
        },
        serial1: undefined,
        serial2: undefined
    }
  },

  methods: {
    async onClick (evt, doneFn) {
        const result = await request({
            url: 'syncdatetime',
            method: 'post',
            data: {
                serial1: this.serial1,
                serial2: this.serial2
            }
        })

        this.alert = result
            ? { show: true, type: 'success', message: 'Salvo com sucesso!' }
            : { show: true, type: 'danger', message: 'Erro ao salvar!' }
    }
  },

  created () {
    addCls('body', 'gray-bg')
  }
}
</script>